/*
 * @Author: 刘怡 
 * @Date: 2022-11-02 15:18:51 
 * @Last Modified by: 刘怡
 * @Last Modified time: 2022-11-02 15:49:37
 */
import request from '@/utils/request2';
export function reportList(data) {
  return request.post('admin/policy/claims', data);
}